import _ from "lodash";
import { canopyActions } from "../../../../../Redux";

const updateInputInStore = (dispatch, canopy_id, key, changed_value) => {
  dispatch(canopyActions.updateCanopyProperty(canopy_id, key, changed_value, true));
};

export const debouncedUpdateinput = _.debounce(updateInputInStore, 150);
